<template>
  <div class="map-con">
    <el-breadcrumb class="breadcrumb-con" separator="">
      <el-breadcrumb-item><a v-on:click="goback"><i class="el-icon-arrow-left back-icon"></i></a></el-breadcrumb-item>
      <el-breadcrumb-item>
        <div style="color:#fff;font-weight: 600;">{{formatMessage({id:'5g.message.h5.components.web',defaultMessage:'网页'})}}</div>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-breadcrumb class="breadcrumb-con" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><a v-on:click="goback" style="color:#fff;">返回</a></el-breadcrumb-item>
      <el-breadcrumb-item>网页</el-breadcrumb-item>
    </el-breadcrumb> -->
    <iframe :src="webUrl" frameborder="0" class="iframe-con" scrolling="auto"></iframe>
  </div>
</template>
  
<script>
  import { encode, decode } from 'js-base64'
  import{ mapState, mapMutations, mapActions }from'vuex';

  export default {
    name: 'WebContainer',
    props: ['webUrl'],
    computed: {
      // ...mapState({
      //   mobileNo: state=>state.chatRoom.mobileNo, 
      //   serviceNo: state=>state.chatRoom.serviceNo,
      //   channelCode: state=>state.chatRoom.channelCode,
      // })
    },
    // data(){
    //   return {
    //     webUrl: this.webUrl
    //   }
    // },
    methods: {
      goback(){
        this.$emit('goback')
      }
    },

    mounted(){
      // console.log('route params', this.$route.params)
      // const { webUrl } = this.$route.params;
      // const reallyUrl = decodeURIComponent(webUrl)
      // console.log('decodeURIComponent URL', reallyUrl)
      // this.webUrl = reallyUrl;
      // console.log('reallyUrl', reallyUrl)

      window.addEventListener('message', function(e) {
        const msgData = e.data||{};
        console.log('接收MSG：',msgData);
        if (msgData.openWindow) {
          window.open(msgData.url,'_self');
          // window.open(msgData.url);
        }
      }, false);
    }
  }
</script>

<style lang="less">
  .map-con{
    width: 100%;
    max-width: 413px;
    height: 100%;
    position: absolute;
    border-right: 1px solid #dbdbdb;
  }
  .iframe-con{
    overflow: hidden;
    height: calc( 100% - 48px );
    width: 100%;
    margin-top: 48px;
    /* position: absolute;
    left: 0; */
  }
  .map{
    /* height: calc( 100% - 70px ); */
    height: 400px;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/WebContainer.vue